<template>
<span>
  <span v-if="lookingForMethodCall">
    If <span class="has-text-danger">->{{ parent.identifier.name }}()</span> is found a search is then done for a child method call of <span class="has-text-danger">->{{ payload.identifier.name }}()</span>
  </span>
</span>
</template>
<script>
export default {
  
  props: {
    parent: {
      type: Object,
      default: () => ({})
    },
    payload: {
      type: Object,
      default: () => ({})
    }
  },

  computed: {
    type() {
      return this.payload.type
    },
    lookingForMethodCall() {
      return this.type === 'method_call'
    }
  }

}
</script>